import {OptionItem} from './optionItem';
import {StorageService} from '../services/storage.service';
import {Option} from './option';

/**
 * Created by strunz on 10.05.2017.
 */
export class Program {
    name: string;
    options = {};
    product: string;
    showAble = false;
    teaserImage = '';
    flagImage: string;
    teaserText: string;
    teaserTitle: string;
    productTeaserName: string;
    price: string;
    ageFrom: number;
    url: string;
    duration: any = {from: 0, unit: null};

    constructor(programData, private storageService: StorageService) {
        this.name = programData.externalName;
        this.product = programData.twProduct;
        this.teaserImage = programData.teaserImage;
        this.flagImage = programData.flagImage;
        this.teaserText = programData.teaserText;
        this.teaserTitle = programData.teaserTitle;
        this.productTeaserName = programData.productTeaserName;
        this.price = programData.price;
        this.ageFrom = programData.ageFrom;
        this.url = programData.url;
        if (programData.duration) {
            this.duration = programData.duration;
        }
        for (const optionName in programData.options) {
            const optionDummy = {
                id: optionName,
                label: optionName,
                subItems: []
            }
            this.options[optionName] = new Option(optionDummy);
            if (storageService.options[optionName]) {
                this.options[optionName].logic = storageService.options[optionName].logic;
                this.options[optionName].type = storageService.options[optionName].type;
            } else {
                console.log('Option ' + optionName + ' missing');
            }
            if (this.storageService.options[optionName]) {
                const allItems = this.storageService.options[optionName].getAllItems();
                for (const programOption in programData.options[optionName]) {
                    for (const optionItem in allItems) {
                        if (programData.options[optionName][programOption].toString() === allItems[optionItem].id.toString()) {
                            this.options[optionName].subItems.push(allItems[optionItem]);
                        }
                    }
                }
            }
        }
    }

    checkOptions(option: Option) {
        if (this.options.hasOwnProperty(option.id)) {
            const optionItems = option.getSelectedItems();
            if (option.logic === 'OR') {
                // OR logic
                if (optionItems.length === 0) {
                    return false;
                }
            } else {
                // AND logic
                if (optionItems.length !== this.storageService.options[option.id].getSelectedItems().length) {
                    return false;
                }
            }
        }
        return true;
    }

    updateShowAble(): void {
        for (const option in this.options) {
            // ignore if option is not filtered
            if (this.storageService.options[option]) {
                if (this.storageService.options[option].getSelectedItems().length > 0
                    && (this.storageService.options[option].ignore !== true
                        || this.storageService.options[option].logic == 'AND')) {
                    if (!this.checkOptions(this.options[option])) {
                        this.showAble = false;
                        return;
                    }
                }
            }
        }
        this.showAble = true;
    }
}